const CAROUSEL_ITEMS = [
  {
    id: 1,
    title: '暑期档必看TOP10',
    desc: '2025暑期最值得期待的大片合集，动作科幻动画一网打尽',
    tag: '热门专题',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20abstract%20visual%20with%20warm%20golden%20and%20crimson%20gradients%2C%20dramatic%20atmosphere%2C%20dark%20rich%20background%2C%20no%20text%2C%20professional%20movie%20poster%20aesthetic&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '高分经典重温',
    desc: '豆瓣8.5+经典影片回顾，那些值得反复观看的传世佳作',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20retrospective%20abstract%20visual%20in%20warm%20sepia%20and%20amber%20tones%2C%20nostalgic%20cinematic%20mood%2C%20dark%20elegant%20backdrop%2C%20no%20text%2C%20sophisticated%20film%20aesthetic&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '悬疑烧脑特辑',
    desc: '层层反转的悬疑佳作盘点，挑战你的推理极限与观察力',
    tag: '类型精选',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20abstract%20visual%20with%20deep%20shadowy%20warm%20tones%2C%20dramatic%20contrast%20lighting%2C%20suspenseful%20atmosphere%2C%20dark%20rich%20background%2C%20no%20text%2C%20cinematic%20noir%20aesthetic&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '科幻巨制合集',
    desc: '超越想象的科幻大片全收录，探索未来与宇宙的无限可能',
    tag: '类型精选',
    img: 'https://readdy.ai/api/search-image?query=Science%20fiction%20abstract%20visual%20with%20cosmic%20warm%20nebulae%20colors%2C%20deep%20crimson%20and%20gold%20accents%2C%20futuristic%20atmosphere%2C%20dark%20spacious%20background%2C%20no%20text%2C%20epic%20cinematic%20quality&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '动漫热血番推荐',
    desc: '最新最热的动漫新番合集，热血治愈总有一款适合你',
    tag: '热门专题',
    img: 'https://readdy.ai/api/search-image?query=Anime%20abstract%20visual%20with%20vibrant%20warm%20colors%2C%20dynamic%20energy%2C%20crimson%20and%20golden%20gradients%2C%20stylish%20dark%20background%2C%20no%20text%2C%20modern%20illustration%20aesthetic&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '爆笑喜剧专场',
    desc: '欢乐不断的喜剧电影合集，让你从头笑到尾停不下来',
    tag: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=Comedy%20film%20abstract%20visual%20with%20bright%20warm%20coral%20and%20amber%20tones%2C%20joyful%20vibrant%20atmosphere%2C%20dark%20rich%20background%2C%20no%20text%2C%20energetic%20cinematic%20aesthetic&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">精彩专题</h2>
          <p className="text-sm text-foreground-500 mt-2">精选优质内容合集，发现更多好片</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-950 rounded-xl overflow-hidden cursor-pointer h-64 md:h-72 hover:scale-[1.02] transition-transform duration-300"
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block text-[10px] px-2 py-0.5 bg-accent-500/90 text-background-50 rounded font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-bold text-background-50 mb-1">{item.title}</h3>
                <p className="text-xs text-background-200/80 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}